import React, { useEffect, useRef } from 'react';
import './Waveform.css';

const Waveform = ({ isActive = true, barCount = 30 }) => {
  const barsRef = useRef([]);

  useEffect(() => {
    if (!isActive) return;

    const interval = setInterval(() => {
      barsRef.current.forEach((bar, i) => {
        if (bar) {
          const height = 20 + Math.random() * 60;
          bar.style.height = `${height}%`;
        }
      });
    }, 100);

    return () => clearInterval(interval);
  }, [isActive]);

  return (
    <div className="waveform-container">
      {Array(barCount).fill().map((_, i) => (
        <div
          key={i}
          ref={el => barsRef.current[i] = el}
          className="waveform-bar"
          style={{
            animationDelay: `${i * 0.05}s`,
            height: '20%'
          }}
        />
      ))}
    </div>
  );
};

export default Waveform;
